import moment from "moment";
//  Metadata Formatter
export const formatMetadata = (powerapp, utils) => {

  // Calculate sales percentages
  let salesSwiped = 0,
    salesKeyed = 0,
    salesInternet = 0;
  if (powerapp.powerappbusinessprofile?.origination_of_transaction) {
    const origination = powerapp.powerappbusinessprofile.origination_of_transaction;
    salesSwiped = origination?.sales_swiped || 0;
    salesKeyed = origination?.sales_keyed || 0;
    salesInternet = origination?.internet || 0;
  }

  const data = {
    Office: powerapp.ems_office_id || "",
    MerchantData: {
      EIN: powerapp.field_ein?.replace(/[^0-9]/g, "") || "",
      LegalName: powerapp.field_legalname || "",
      DbaName: powerapp.field_dba || "",
      DbaAddress: {
        Street: powerapp.field_dbastreet || "",
        Zip: powerapp.field_dbazip || "",
        City: powerapp.field_dbacity || "",
        State: powerapp.field_dbastate,
      },
      DbaPhone: powerapp.field_dbaphone || powerapp.field_businessphone,
      OwnershipType: utils.normalizeOwnershipType(powerapp.field_ownership), // Use normalized value
      GoodsSold:
        powerapp.powerappbusinessprofile?.product_service_sold?.substring(
          0,
          256,
        ) || "",
      MccId: powerapp.field_mcc || 1657,
      AvgMonthlySales: powerapp.bankinfo?.maxsales || 0,
      AvgTicket: powerapp.bankinfo?.ticketaverage || 0,
      HighTicket: powerapp.bankinfo?.tickethighest || 0,
      URL: powerapp.field_website || "",
      BusinessPhone: (powerapp.field_businessphone),
      BusinessEmail: powerapp.field_businessemail || "",
      OwnershipLengthYr: powerapp.field_ownershipyears || 0,
      OwnershipLengthMo: powerapp.field_ownershipmonths || 0,
      OriginationOfTransaction: {
        InternetPercent: salesInternet,
        SwipedPercent: salesSwiped,
        KeyedPercent: salesKeyed,
      }
    },
    BankData: {
      RoutingNum: powerapp.bankinfo?.bankrouting || "",
      AccountNum: powerapp.bankinfo?.bankaccount || "",
    },
    UDWNotes: powerapp.uw_notes || "",
    billingSequence: powerapp.billing?.billing_sequence || "",
    expeditedFunding: powerapp.billing?.expedited_funding || "",
    specialInstruction: powerapp.billing?.special_instruction || "",
    appPdfBundle: powerapp.combined_files || "",
  };

  if (powerapp.same_as_legal != "yes") {
    data.MerchantData.LegalAddress = {
      Street: powerapp.field_legalstreet,
      Zip: powerapp.field_legalzip,
      City: powerapp.field_legalcity,
      State: powerapp.field_legalstate,
    };
    data.MerchantData.LegalPhone = powerapp.field_businessphone;
  }

  // Add owner information
  const owner1 = {
    FirstName: powerapp.field_firstname || "",
    LastName: powerapp.field_lastname || "",
    DOB: powerapp.field_birthdate
      ? moment(powerapp.field_birthdate).format("YYYY-MM-DD")
      : "",
    SSN: powerapp.field_socialsecurity?.replace(/[^0-9]/g, "") || "",
    OwnershipPercent: powerapp.field_ownershippercentage || 0,
  };

  if (powerapp.personal_same_as_dba_legal == null) {
    owner1.Address = {
      Street: powerapp.field_personalstreet,
      Zip: powerapp.field_personalzip,
      City: powerapp.field_personalcity,
      State: powerapp.field_personalstate,
    };
    owner1.Email = powerapp.field_email;
    owner1.MobilePhone = (powerapp.field_personalphone);
  }

  if (powerapp.personal_same_as_dba_legal == 'dba') {
    owner1.Address = {  
      Street: powerapp.field_dbastreet,
      Zip: powerapp.field_dbazip,
      City: powerapp.field_dbacity,
      State: powerapp.field_dbastate,
    };
    owner1.Email = powerapp.field_email;
    owner1.MobilePhone = (powerapp.field_personalphone);
  }

  if (powerapp.personal_same_as_dba_legal == 'business') {
    owner1.Address = {  
      Street: powerapp.field_legalstreet,
      Zip: powerapp.field_legalzip,
      City: powerapp.field_legalcity,
      State: powerapp.field_legalstate,
    };
    owner1.Email = powerapp.field_businessemail;
    owner1.MobilePhone = (powerapp.field_businessphone);
  }

  owner1.DocumentType = powerapp.field_documenttype;
  owner1.DocumentNumber = powerapp.field_documentnumber;
  owner1.DocumentCountry = powerapp.document_country;
  owner1.DocumentState = powerapp.field_driverstate;

  data.Owners = [owner1];

  // Add additional owners from signers
  if (powerapp.signers && powerapp.signers.length > 0) {
    powerapp.signers.forEach((signer) => {
      const owner = {
        FirstName: signer.first_name || "",
        LastName: signer.last_name || "",
        Title: 9,
        Management: true,
        Address: {
          Street: signer.address_street || "",
          Zip: signer.address_zip_code || "",
          City: signer.address_city || "",
          State: signer.address_state,
        },
        DOB: signer.date_of_birth
          ? moment(signer.date_of_birth).format("YYYY-MM-DD")
          : "",
        SSN: signer.social_security?.replace(/[^0-9]/g, "") || "",
        HomePhone: (signer.phone || ""),
        Email: signer.email || "",
        MobilePhone: (signer.phone || ""),
        Signer: true,
        OwnershipPercent: signer.ownership_percentage || 0,
      };

      owner.DocumentType = signer.document_type;
      owner.DocumentNumber = signer.drivers_license_number;
      owner.DocumentCountry = signer.document_country;
      owner.DocumentState = signer.drivers_license_state;

      data.Owners.push(owner);
    });
  }

  return data;
}; 